<!-- 面包屑 -->
<template>
  <div class="v-breadcrumb" v-if="showBreadcrumb">
    <!-- 首页 -->
    <span>
      <a class="v-breadcrumb__home-link" href="/">{{ $t('home.home') }}</a>
    </span>

    <!-- 显示来源 -->
    <template v-if="showFromPath && referrerData.href">
      <span class="v-breadcrumb__line">/</span>
      <span :style="{ maxWidth: '100px' }">
        <a :href="referrerData.href">
          {{ referrerData['title'] || $t(routerList[referrerData['route']]) }}
        </a>
      </span>
    </template>

    <!-- 当前页面 -->
    <template v-if="routerList[route] || title">
      <span class="v-breadcrumb__line"> / </span>
      <span :style="{ maxWidth: '186px' }">
        {{ title || $t(routerList[route]) }}
      </span>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { urlToQueryData } from '../lib/util'

// 允许可显示的来源页面
const allowFromRoute = ['collections', 'collection-index', 'collection-show', 'collections-all', 'blogs-show']

export default {
  name: 'v-breadcrumb',
  props: {
    // 自定义页面标题
    title: {
      type: String,
      default: null,
    },
    // 显示来源（上一级）路径
    showFromPath: {
      type: Boolean,
      default: false,
    },
    // 路由
    route: {
      type: String,
      default: null,
    },
    // 扩张字段，特殊情况，用于特殊判断
    extendData: {
      type: String|Object,
      default: null
    }
  },
  data() {
    return {
      // 路由列表，用于多语言翻译
      routerList: {
        search: 'venue.home.search',
        'collection-index': 'comment.collections',
        collections: 'comment.collections',
        'collections-all': 'productList.products',
        cart: 'venue.home.shopping_cart',
        search: 'venue.home.search',
        reviews: 'comment.customer_review',
      },
      // 来源页面的相关信息
      referrerData: {
        title: null,
        route: null,
        href: null,
      },
    }
  },
  computed: {
    ...mapState({
      showBreadcrumb: ({ options }) => options?.theme?.modules?.header?.show_breadcrumb,
    }),
  },
  mounted() {
    // 保存当前页面信息
    this.setPageData()
    // 获取上个页面的信息
    this.getReferrerData()
  },
  methods: {
    /**
     * 记录当前页面的一些信息
     *
     */
    setPageData() {
      // 页面信息
      const pageData = urlToQueryData(location.href)
      const pathName = pageData?.pathName

      // 保存在session
      sessionStorage.setItem(
        `bread_${pathName}`,
        JSON.stringify({
          title: this.title,
          route: this.route,
          href: location.href,
        })
      )
    },
    /**
     *  获取上个页面的信息
     */
    getReferrerData() {
      const referrer = document.referrer
      if (!referrer) return

      // 来源页面
      const referrerData = urlToQueryData(referrer)
      const pathName = referrerData?.pathName

      // 从url中获取的pathName可能是详情页之类的名称
      // 需要从sessionStorage中读取
      const pageData = JSON.parse(sessionStorage.getItem(`bread_${pathName}`))

      // 没有上个页面的信息或属于同一个页面
      if (!pageData || pageData.route === this.route) return

      // 特殊处理:
      if (this.route === 'product-index') {
        // 详情页允许来自 所有产品页和分类页
        if (!['collections-all', 'collection-show'].includes(pageData.route)) return

        // 产品详情页，来源是隶属的分类页的
        if (pageData.route === 'collection-show' && this.extendData) {
          const productCollection = this.extendData?.map(item => item?.name)
          if (!productCollection.includes(pageData.title)) return
        }
      } 

      // 如果是博客详情页
      if (this.route === 'blog-detail') {
        if (!['blogs-show'].includes(pageData.route)) return

        // 如果来源分类页，非隶属关系
        if (pageData.route === 'blogs-show' && this.extendData) {
          const blogCollections = this.extendData?.map(item => item?.title)
          if (!blogCollections.includes(pageData.title)) return
        }
      }

      // 允许显示来源
      if (allowFromRoute.includes(pageData.route) ) {
        this.referrerData.title = pageData.title
        this.referrerData.route = pageData.route
        this.referrerData.href = referrer
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-breadcrumb {
  color: #2f2f2f;
  text-align: left;
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 14px;
  &__home-link {
    color: var(--main-btn-bg);
  }
  span {
    text-transform: capitalize;
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__line {
    margin-left: 4px;
    margin-right: 4px;
    color: #2f2f2f;
  }
  a {
    text-decoration: none
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
}
</style>
